import React, { lazy } from 'react';
import { IdentificationModalWrapper, ModalOptions } from '@fiverr-private/identification_core';

const LazyIdentificationForm = lazy(
    () => import(/* webpackChunkName: "LazyIdentificationForm" */ '../../components/IdentificationForm')
);

export interface IdentificationModalProps {
    googleClientId: string;
    autoShowSignUpEnabled?: boolean;
    inLynxesIdentificationResetPasswordRollout?: boolean;
    inLynxesIdentificationIllustrationRollout?: boolean;
    inLynxesGoogleOneTapFedCmRollout?: boolean;
    variant?: ModalOptions['variant'];
    inLynxesIdentificationResetPasswordFlowMixpanelRecordingsRollout?: boolean;
    inBeetlesMigrateSignupWebRollout: boolean;
    inBeetlesMigrateSigninWebRollout: boolean;
    inBeetlesMigrateSocialSignUpRollout: boolean;
    inLynxesRemoveQuestionnaireFromBlockedActionsRollout?: boolean;
}

export const IdentificationModal = ({
    googleClientId,
    autoShowSignUpEnabled,
    inLynxesIdentificationResetPasswordRollout,
    inLynxesIdentificationIllustrationRollout,
    inLynxesGoogleOneTapFedCmRollout,
    variant: variantProp,
    inLynxesIdentificationResetPasswordFlowMixpanelRecordingsRollout,
    inBeetlesMigrateSignupWebRollout,
    inBeetlesMigrateSigninWebRollout,
    inBeetlesMigrateSocialSignUpRollout,
    inLynxesRemoveQuestionnaireFromBlockedActionsRollout,
}: IdentificationModalProps) => (
    <IdentificationModalWrapper
        googleClientId={googleClientId}
        autoShowSignUpEnabled={autoShowSignUpEnabled}
        variant={variantProp}
        inLynxesGoogleOneTapFedCmRollout={inLynxesGoogleOneTapFedCmRollout}
        renderLazyComponent={({
            isModal,
            isModalOpen,
            closeModal,
            mode,
            variant,
            triggerType,
            redirectUrl,
            email,
            username,
            isSticky,
            skipQuestionnaire,
            blockedActionType,
            bigQueryEnrichment,
            mixpanelEnrichment,
            afterSigningSuccess,
            isSocialFlow,
            stepId,
            skipActivation,
            isCodeActivationSkippable,
        }) => (
            <LazyIdentificationForm
                isModal={isModal}
                isModalOpen={isModalOpen}
                closeModal={closeModal}
                mode={mode}
                variant={variant}
                triggerType={triggerType}
                redirectUrl={redirectUrl}
                email={email}
                username={username}
                isSticky={isSticky}
                skipQuestionnaire={skipQuestionnaire}
                blockedActionType={blockedActionType}
                mixpanelEnrichment={mixpanelEnrichment}
                bigQueryEnrichment={bigQueryEnrichment}
                afterSigningSuccess={afterSigningSuccess}
                isSocialFlow={isSocialFlow}
                stepId={stepId}
                skipActivation={skipActivation}
                isCodeActivationSkippable={isCodeActivationSkippable}
                inLynxesIdentificationResetPasswordRollout={inLynxesIdentificationResetPasswordRollout}
                inLynxesIdentificationIllustrationRollout={inLynxesIdentificationIllustrationRollout}
                inLynxesIdentificationResetPasswordFlowMixpanelRecordingsRollout={
                    inLynxesIdentificationResetPasswordFlowMixpanelRecordingsRollout
                }
                inBeetlesMigrateSignupWebRollout={inBeetlesMigrateSignupWebRollout}
                inBeetlesMigrateSigninWebRollout={inBeetlesMigrateSigninWebRollout}
                inBeetlesMigrateSocialSignUpRollout={inBeetlesMigrateSocialSignUpRollout}
                inLynxesRemoveQuestionnaireFromBlockedActionsRollout={
                    inLynxesRemoveQuestionnaireFromBlockedActionsRollout
                }
            />
        )}
    />
);
